export const VACANCY_INNER_DETAILS_REQUEST = 'VACANCY_INNER_DETAILS_REQUEST'
export const VACANCY_INNER_DETAILS_RECEIVE = 'VACANCY_INNER_DETAILS_RECEIVE'
